import styled from "styled-components";

export const StyledOrderedList = styled.ol`
  color: ${({ theme }) => theme.text.default};
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-size: 0.88em;
  line-height: 1.56em;
  font-variation-settings: "slnt" 0;
  margin: 0;
  padding-left: 1.5em;

  li::marker {
    font-family: "Inter", sans-serif;
    font-optical-sizing: auto;
    font-weight: 400;
    font-size: 0.88em;
    font-variation-settings: "slnt" 0;
  }

  @media (max-width: 340px) {
    font-size: 0.7em;
  }
`;

export const StyledUnorderedList = styled.ul`
  color: ${({ theme }) => theme.text.default};
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-size: 0.88em;
  line-height: 1.56em;
  font-variation-settings: "slnt" 0;
  margin: 0;
  padding-left: 1.5em;

  li::marker {
    font-family: "Inter", sans-serif;
    font-optical-sizing: auto;
    font-weight: 400;
    font-size: 0.88em;
    font-variation-settings: "slnt" 0;
  }

  @media (max-width: 340px) {
    font-size: 0.7em;
  }
`;
